import { render, staticRenderFns } from "./MapColumns.vue?vue&type=template&id=58ad0a9f"
import script from "./MapColumns.vue?vue&type=script&lang=js"
export * from "./MapColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports